import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { SessionProvider, useSession } from './SessionProvider';
import { LoadingBlock } from '../ui';

/** Загружает сессию (cookie) и ждёт её перед показом кабинетов */
export function RequireAuth() {
  return (
    <SessionProvider>
      <SessionGate />
    </SessionProvider>
  );
}

function SessionGate() {
  const location = useLocation();
  const { loading, admin } = useSession();
  if (loading) return <LoadingBlock className="min-h-full" />;
  // Сессии нет или она завершена — на вход
  if (!admin) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return <Outlet />;
}

/** Кабинет по роли: владелец — консоль, сотрудники компании — кабинет компании */
export function HomeRedirect() {
  const { isOwner } = useSession();
  return <Navigate to={isOwner ? '/owner' : '/company'} replace />;
}

export function OwnerOnly({ children }) {
  const { isOwner } = useSession();
  return isOwner ? children : <Navigate to="/company" replace />;
}

/** Кабинет компании: роли компании или владелец, открывший компанию */
export function CompanyOnly({ children }) {
  const { isOwner, company } = useSession();
  if (isOwner && !company) return <Navigate to="/owner/companies" replace />;
  return children;
}

// Адреса старой админки → раздел текущего кабинета (ссылки внутри ещё не переделанных страниц)
const LEGACY = {
  dashboard: { owner: '', company: '' },
  tenants: { owner: 'companies', company: '' },
  billing: { owner: 'billing', company: '' },
  users: { owner: 'employees', company: 'employees' },
  reports: { owner: 'analytics', company: 'analytics' },
  push: { owner: 'notifications', company: 'notifications' },
  logs: { owner: 'logs', company: '' },
  'logs/list': { owner: 'logs', company: '' },
  security: { owner: 'security', company: '' },
  sql: { owner: 'sql', company: '' },
  settings: { owner: 'settings', company: '' },
};

export function LegacyRedirect({ from }) {
  const { isOwner, isViewingAsOwner } = useSession();
  const location = useLocation();
  const inOwnerConsole = isOwner && !isViewingAsOwner;
  const target = LEGACY[from]?.[inOwnerConsole ? 'owner' : 'company'] ?? '';
  const base = inOwnerConsole ? '/owner' : '/company';
  return <Navigate to={`${base}${target ? `/${target}` : ''}${location.search}`} replace />;
}

export const LEGACY_PATHS = Object.keys(LEGACY);

